import {Injectable} from '@angular/core';
import {RequesterService} from '../../../services/requester.service';
import {ELearningListItemModel, ELearningReportModel} from '../models/e-learning-list-item.model';
import {RequesterResponseModel} from '../../../services/models/requester.model';
import {EventsService} from '../../../services/events.service';

@Injectable({
    providedIn: 'root'
})
export class ELearningService {

    constructor(
        private event: EventsService,
        private requesterService: RequesterService
    ) {
    }

    registeredToRunIds = [];

    myElearningListExired = null;
    myElearningListValid = false;
    myElearningListPromise = null;

    getMyElearningList(): Promise<Array<ELearningListItemModel>> {
        if (this.myElearningListPromise === null || !this.myElearningListValid) {
            this.myElearningListPromise = this.requesterService.get('getMyElearningList',
                {update: this.registeredToRunIds})
                .then(data => {
                    if (!!data.result && Array.isArray(data.result)) {
                        return data.result;
                    } else {
                        return [];
                    }
                }).catch(e => {
                    return [];
                    console.log('Error getMyElearningList >> ', e);
                });
            this.myElearningListValid = true;
            this.myElearningListExired = new Date();
        }

        return this.myElearningListPromise;
    }

    getMyElearningReport(programDelegateId: number, forceUpdate = false): Promise<ELearningReportModel> {
        if (this.registeredToRunIds.indexOf(programDelegateId) >= 0) {
            forceUpdate = true;
            this.registeredToRunIds = this.registeredToRunIds.filter(item => item !== programDelegateId);
        }
        return this.requesterService.get('getMyElearningReport',
            {prog_del_id: programDelegateId, update: forceUpdate})
            .then(data => {
                if (!!data.result) {
                    if (forceUpdate) {
                        this.event.publish(
                            'e-learning:getMyElearningReport:forceUpdate',
                            {
                                programDelegateId: programDelegateId,
                                status: data.result.result.status === 'Completed'
                            });
                    }
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error getMyElearningReport >> ', e);
            });
    }

    registerMyElearningRun(programDelegateId: number): Promise<RequesterResponseModel> {
        return this.requesterService.post('registerMyElearningRun', {prog_del_id: programDelegateId})
            .then(data => {
                if (!!data.result) {
                    if (this.registeredToRunIds.indexOf(programDelegateId) < 0) {
                        this.registeredToRunIds.push(programDelegateId);
                    }

                    this.event.publish('e-learning:registerMyElearningRun', programDelegateId);
                    return data.result;
                } else {
                    return null;
                }
            }).catch(e => {
                return null;
                console.log('Error registerMyElearningRun >> ', e);
            });
    }
}
